/* eslint-disable camelcase */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Card from './card';
import CardContent from './card-content';
import classnames from 'classnames';
import looppa from 'looppa';
import t from 'translations';
import { get } from 'lodash';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import staticPath from 'util/misc/static-assets-path';
import tracking from 'tracking';

import { CARD } from 'constants/placeholder-events';
import CardSlider from './card-slider';
import CardContentLite from './card-content-lite';
import Button from 'components/button';

class CardStack extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        style: PropTypes.string.isRequired,
        app_store_link: PropTypes.string,
        google_play_link: PropTypes.string,
        show_footer: PropTypes.bool.isRequired,
        sub_text: PropTypes.string,
        cards: PropTypes.array.isRequired,
        index: PropTypes.number.isRequired,
        sliderIsOpen: PropTypes.string,
        onEvent: PropTypes.func,
        openModal: PropTypes.func.isRequired,
        isMobile: PropTypes.bool.isRequired,
        sub_links: PropTypes.array,
        isModalOpen: PropTypes.bool.isRequired,
        features: PropTypes.array,
    };

    state = {
        isOpen: false,
        sliderHeight: false,
    };

    componentWillReceiveProps({ sliderIsOpen, isModalOpen, onEvent }) {
        // close the cards in case an overlay will be opened
        if (isModalOpen && !this.props.isModalOpen) {
            onEvent(CARD, { sliderIsOpen: null });
        }

        if (sliderIsOpen !== this.props.sliderIsOpen) {
            if (sliderIsOpen === this.cardPosition) {
                this.setState({
                    sliderHeight: this.getSliderHeight(),
                });
            } else {
                this.setState({
                    sliderHeight: false,
                });
            }
        }
    }

    get cardPosition() {
        return this.props.index ? 'right' : 'left';
    }

    get cards() {
        const { cards } = this.props;
        return this.isOverlay ? cards.slice(1) : cards;
    }

    get firstCard() {
        return this.props.cards[0];
    }

    get isInline() {
        return this.style === 'inline';
    }

    get isOverlay() {
        return this.style === 'overlay';
    }

    /**
     * Check whether the current slider is open
     * @returns {boolean}
     */
    get ownSliderIsOpen() {
        const { sliderIsOpen } = this.props;
        return sliderIsOpen === this.cardPosition || this.style === 'inline';
    }

    getSliderHeight() {
        const sliderDOMNode = get(this, 'refs.slider-wrapper.childNodes.0.childNodes.0', false);

        if (sliderDOMNode) {
            return sliderDOMNode.offsetHeight;
        }

        return 0;
    }

    /* TODO: Remove after prelaunch is over */
    showPrelaunchModal = () => {
        this.props.openModal({
            layout: 'prelaunch',
            meta: {
                titlePath: 'prelaunch.modal.title',
            },
        });
    };

    showZipModal = () => {
        this.props.openModal({
            layout: 'zip-form',
        });
    };

    /**
     * If we're on a mobile viewport, always return inline as per design
     * @returns {*}
     */
    get style() {
        return this.props.style;
    }

    triggerEvent = () => {
        const { onEvent } = this.props;

        if (onEvent) {
            onEvent(CARD, { sliderIsOpen: this.cardPosition });
            tracking.buttonClick({ buttonText: this.firstCard ? this.firstCard.title : 'Open cards' });
        }
    };

    renderAppStoreLinks = () => {
        const { app_store_link, google_play_link, sub_links, show_footer } = this.props;

        if (!show_footer) {
            return null;
        }

        return (
            <div className="cms-card-stack--actions">
                {google_play_link && (
                    <div className="cms-card-stack--action">
                        <a aria-label={t('accessibility.label.buy_on_googleplay')}
                            className="cms-card-stack--app-store-link u-reset" href={google_play_link} target="_blank">
                            <img
                                width="162"
                                className="cms-card-stack--app-store-img"
                                src={staticPath('img/logos/im-googleplay-badge.svg')}
                            />
                        </a>
                    </div>
                )}
                {app_store_link && (
                    <div className="cms-card-stack--action">
                        <a aria-label={t('accessibility.label.buy_on_appstore')}
                            className="cms-card-stack--app-store-link u-reset" href={app_store_link} target="_blank">
                            <img
                                width="162"
                                className="cms-card-stack--app-store-img"
                                src={staticPath('img/logos/im-appstore-badge.svg')}
                            />
                        </a>
                    </div>
                )}
                {looppa(sub_links)((subLink, index) => (
                    <div key={index} className="cms-card-stack--action cms-card-stack--action__link">
                        <Button
                            tag={'button'}
                            className="cms-card-stack--link"
                            facet={['x-large', subLink.style]}
                            onClick={subLink.to === 'email' ? this.showPrelaunchModal : this.showZipModal}
                        >
                            {subLink.label}
                        </Button>
                    </div>
                ))}
            </div>
        );
    };

    renderCardSub = () => {
        const { sub_text, app_store_link, google_play_link, sub_links, show_footer } = this.props;

        if (show_footer && (sub_text || app_store_link || google_play_link || sub_links)) {
            return (
                <div className="cms-card-stack--sub">
                    {sub_text && <div className="cms-card-stack--sub-text">{sub_text}</div>}
                    {this.renderAppStoreLinks()}
                </div>
            );
        }

        return null;
    };

    renderSlider() {
        const { onEvent, features, app_store_link, google_play_link } = this.props;

        return (
            <div ref="slider-wrapper" className={classnames('cms-card-stack--slider', {
                'cms-card-stack--slider__is-overlay': this.isOverlay,
            })}>
                {this.cards && (
                    <CardSlider
                        ref='slider'
                        cards={this.cards}
                        style={this.style}
                        isOpen={this.ownSliderIsOpen}
                        onEvent={onEvent}
                        features={features}
                        app_store_link={app_store_link}
                        google_play_link={google_play_link}
                    />
                )}
            </div>
        );
    }

    renderCardLite() {
        return <CardContentLite {...this.props} facet={this.cardPosition}/>;
    }

    renderCardDefault() {
        return <CardContent firstCard {...this.firstCard} visible={true}/>;
    }

    render() {
        const { title, sliderIsOpen, isMobile } = this.props;
        const { sliderHeight } = this.state;
        const isLite = isMobile && !this.isInline;
        return (
            <div
                style={sliderHeight ? {
                    height: sliderHeight,
                } : null}
                className={classnames(
                    `cms-card-stack cms-card-stack__${ this.style } cms-card-stack__${ this.cardPosition }`,
                    { 'cms-card-stack__slider-is-open': sliderIsOpen },
                )}
            >
                <section className="cms-card-stack--inner">
                    <div className="cms-card-stack--base">
                        <header className="cms-card-stack--header">
                            <h2 className="cms-card-stack--title u-reset">{title}</h2>
                        </header>
                        {this.isOverlay && (
                            <button aria-label={this.firstCard.title} className="cms-card-stack--preview"
                                onClick={this.triggerEvent}>
                                <Card facet={['shadow', this.cardPosition]}>
                                    {isLite ? this.renderCardLite() : this.renderCardDefault()}
                                </Card>
                            </button>
                        )}
                        {this.isInline && this.renderSlider()}
                        {this.renderCardSub()}
                    </div>
                    {this.isOverlay && this.renderSlider()}
                </section>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isMobile: 'viewport.isMobile',
        isModalOpen: 'modal.isVisible',
    }),
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
    }),
)(CardStack);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/card-stack/index.js